const libPictView = require('pict-view');
const libBrand = require('../Plansheet-Brand.js');
const libProviderLabels = require('../OAuth-Provider-Labels.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Plansheet-Auth',
	DefaultRenderable: 'Auth-Display',
	CSS: /*css*/`
		/* Sign-in stands on its own: hide the app chrome and fill the viewport. */
		body.plansheet-auth-mode .pict-modal-shell-panel { display: none !important; }
		.cst-auth
		{
			position: fixed; inset: 0; z-index: 40;
			display: flex; align-items: center; justify-content: center;
			padding: 32px 20px; overflow: auto;
			background: var(--theme-color-background-primary, #f6f8fb);
		}
		.cst-auth-stage { width: 100%; max-width: 380px; display: flex; flex-direction: column; align-items: center; }
		.cst-auth-brand { display: flex; flex-direction: column; align-items: center; gap: 14px; margin-bottom: 26px; }
		.cst-auth-mark svg { width: 76px; height: 76px; display: block; }
		.cst-auth-wordmark { font-size: 34px; font-weight: 700; letter-spacing: -0.5px; color: var(--theme-color-text-primary, #1d2230); }
		.cst-auth-card
		{
			width: 100%;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #e4e8ef);
			border-radius: 14px;
			padding: 26px 26px 22px;
			box-shadow: 0 8px 30px rgba(20,30,50,0.06);
		}
		.cst-auth-title { font-size: 17px; font-weight: 600; margin: 0 0 4px; text-align: center; color: var(--theme-color-text-primary, #2c3140); }
		.cst-auth-subtitle { font-size: 13px; color: var(--theme-color-text-secondary, #5b6376); margin: 0 0 20px; text-align: center; }
		.cst-auth-field { display: flex; flex-direction: column; gap: 4px; margin-bottom: 14px; }
		.cst-auth-field label { font-size: 12px; font-weight: 500; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-auth-field input
		{
			width: 100%;
			padding: 10px 12px;
			font-size: 14px;
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px;
			background: var(--theme-color-background-secondary, #f7f8fb);
			color: var(--theme-color-text-primary, #2c3140);
			box-sizing: border-box;
		}
		.cst-auth-field input:focus { outline: none; border-color: var(--theme-color-brand-primary, #2988df); }
		.cst-auth-button
		{
			width: 100%;
			padding: 11px 14px;
			background: var(--theme-color-brand-primary, #2988df);
			color: var(--theme-color-text-on-brand, #fff);
			border: none;
			border-radius: 8px;
			font-weight: 500;
			cursor: pointer;
			font-size: 14px;
			margin-top: 6px;
		}
		.cst-auth-button:disabled { opacity: 0.6; cursor: wait; }
		.cst-auth-otp { text-align: center; letter-spacing: 0.4em; font-size: 20px; font-weight: 600; padding-left: 0.4em; }
		.cst-auth-actions { display: flex; justify-content: space-between; margin-top: 16px; font-size: 13px; }
		.cst-auth-actions a { color: var(--theme-color-brand-primary, #2988df); cursor: pointer; text-decoration: underline; }
		.cst-auth-note { text-align: center; font-size: 12px; color: var(--theme-color-status-success, #1f8a4c); margin-top: 10px; min-height: 14px; }
		.cst-auth-divider
		{
			text-align: center;
			margin: 18px 0;
			color: var(--theme-color-text-secondary, #5b6376);
			font-size: 12px;
			position: relative;
		}
		.cst-auth-divider::before, .cst-auth-divider::after
		{
			content: ""; position: absolute; top: 50%;
			width: calc(50% - 22px); height: 1px;
			background: var(--theme-color-border-default, #d8dde6);
		}
		.cst-auth-divider::before { left: 0; }
		.cst-auth-divider::after  { right: 0; }
		.cst-auth-providers { display: flex; flex-direction: column; gap: 8px; }
		.cst-auth-provider
		{
			padding: 10px 12px;
			background: var(--theme-color-background-secondary, #f7f8fb);
			border: 1px solid var(--theme-color-border-default, #d8dde6);
			border-radius: 8px;
			color: var(--theme-color-text-primary, #2c3140);
			text-decoration: none;
			font-size: 14px;
			text-align: center;
			font-weight: 500;
		}
		.cst-auth-provider:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-auth-toggle
		{
			text-align: center;
			margin-top: 16px;
			font-size: 13px;
			color: var(--theme-color-text-secondary, #5b6376);
		}
		.cst-auth-toggle a { color: var(--theme-color-brand-primary, #2988df); cursor: pointer; text-decoration: underline; }
		.cst-auth-error
		{
			margin: 0 0 12px;
			padding: 10px 12px;
			border-radius: 8px;
			background: var(--theme-color-status-error-background, #fdecec);
			color: var(--theme-color-status-error, #c0353a);
			font-size: 13px;
			border: 1px solid var(--theme-color-status-error-border, #f3c2c2);
		}
		.cst-auth-guest
		{
			text-align: center;
			margin-top: 18px;
			font-size: 12px;
			color: var(--theme-color-text-secondary, #5b6376);
		}
		.cst-auth-guest a { color: var(--theme-color-text-secondary, #5b6376); cursor: pointer; }
	`,
	Templates:
	[
		{
			Hash: 'Auth-Display',
			Template: /*html*/`
<div class="cst-auth" id="Auth-Root">
	<div class="cst-auth-stage">
		<div class="cst-auth-brand">
			<div class="cst-auth-mark">{~D:AppData.Auth.Brand.Mark~}</div>
			<div class="cst-auth-wordmark">{~D:AppData.Auth.Brand.Name~}</div>
		</div>
		<div class="cst-auth-card">
			{~TS:Auth-Login-Template:AppData.Auth.UISlot.Login~}
			{~TS:Auth-Signup-Template:AppData.Auth.UISlot.Signup~}
			{~TS:Auth-Verify-Template:AppData.Auth.UISlot.Verify~}
			{~TS:Auth-Recovery-Template:AppData.Auth.UISlot.Recovery~}
			{~TS:Auth-Enroll-Send-Template:AppData.Auth.UISlot.EnrollSend~}
			{~TS:Auth-Enroll-Code-Template:AppData.Auth.UISlot.EnrollCode~}
		</div>
		<div class="cst-auth-toggle">New to Plansheet? <a href="https://www.plansheet.io/" target="_blank" rel="noopener">Learn more</a></div>
	</div>
</div>`
		},
		{
			Hash: 'Auth-Login-Template',
			Template: /*html*/`
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitLogin();">
	<div class="cst-auth-field">
		<label for="Auth-Login-Username">Email or username</label>
		<input id="Auth-Login-Username" type="text" autocomplete="username" autofocus />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Login-Password">Password</label>
		<input id="Auth-Login-Password" type="password" autocomplete="current-password" />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Login-Submit">Sign in</button>
</form>
<div class="cst-auth-toggle">
	<a onclick="_Pict.views['Plansheet-Auth'].sendMagicLink()">Email me a sign-in link instead</a>
</div>
<div class="cst-auth-note" id="Auth-Magic-Note"></div>
{~TS:Auth-Providers-Template:AppData.Auth.UISlot.HasProviders~}
<div class="cst-auth-toggle">
	No account yet? <a onclick="_Pict.views['Plansheet-Auth'].switchMode('signup')">Create one</a>
</div>`
		},
		{
			Hash: 'Auth-Signup-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Create your account</h2>
<p class="cst-auth-subtitle">Saves your sessions and gives you a timeline across them.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitSignup();">
	<div class="cst-auth-field">
		<label for="Auth-Signup-Email">Email</label>
		<input id="Auth-Signup-Email" type="email" autocomplete="email" autofocus />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Signup-Login">Username</label>
		<input id="Auth-Signup-Login" type="text" autocomplete="username" />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Signup-Display">Display name</label>
		<input id="Auth-Signup-Display" type="text" autocomplete="name" />
	</div>
	<div class="cst-auth-field">
		<label for="Auth-Signup-Password">Password</label>
		<input id="Auth-Signup-Password" type="password" autocomplete="new-password" />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Signup-Submit">Create account</button>
</form>
{~TS:Auth-Providers-Template:AppData.Auth.UISlot.HasProviders~}
<div class="cst-auth-toggle">
	Already have an account? <a onclick="_Pict.views['Plansheet-Auth'].switchMode('login')">Sign in</a>
</div>`
		},
		{
			Hash: 'Auth-Verify-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Enter your code</h2>
<p class="cst-auth-subtitle">We sent a 6-digit code to {~D:Record.MaskedDestination~}. It expires in a few minutes.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitVerify();">
	<div class="cst-auth-field">
		<label for="Auth-Verify-Code">Verification code</label>
		<input id="Auth-Verify-Code" class="cst-auth-otp" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" autofocus />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Verify-Submit">Verify and sign in</button>
</form>
<div class="cst-auth-note">{~D:Record.ResendNote~}</div>
<div class="cst-auth-actions">
	<a onclick="_Pict.views['Plansheet-Auth'].resendCode()">Resend code</a>
	<a onclick="_Pict.views['Plansheet-Auth'].cancelVerify()">Use a different account</a>
</div>
<div class="cst-auth-toggle"><a onclick="_Pict.views['Plansheet-Auth'].toggleRecovery(true)">Use a recovery code instead</a></div>`
		},
		{
			Hash: 'Auth-Recovery-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Enter a recovery code</h2>
<p class="cst-auth-subtitle">Use one of the recovery codes you saved when you turned on two-step verification.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].submitRecovery();">
	<div class="cst-auth-field">
		<label for="Auth-Recovery-Code">Recovery code</label>
		<input id="Auth-Recovery-Code" type="text" autocomplete="one-time-code" placeholder="XXXX-XXXX" autofocus />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Recovery-Submit">Verify and sign in</button>
</form>
<div class="cst-auth-toggle"><a onclick="_Pict.views['Plansheet-Auth'].toggleRecovery(false)">Use the emailed code instead</a></div>`
		},
		{
			Hash: 'Auth-Enroll-Send-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Set up two-step verification</h2>
<p class="cst-auth-subtitle">{~D:Record.OrgLine~} We will email a one-time code to {~D:Record.EmailMasked~}.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<button class="cst-auth-button" id="Auth-Enroll-Send" onclick="_Pict.views['Plansheet-Auth'].enrollSendCode()">Email me a code</button>
<div class="cst-auth-actions">
	<a onclick="_Pict.views['Plansheet-Auth'].enrollSignOut()">Sign out</a>
</div>`
		},
		{
			Hash: 'Auth-Enroll-Code-Template',
			Template: /*html*/`
<h2 class="cst-auth-title">Enter your code</h2>
<p class="cst-auth-subtitle">We emailed a 6-digit code to {~D:Record.Masked~}.</p>
{~TS:Auth-Error-Template:AppData.Auth.UISlot.Error~}
<form onsubmit="event.preventDefault(); _Pict.views['Plansheet-Auth'].enrollConfirm();">
	<div class="cst-auth-field">
		<label for="Auth-Enroll-Code">Verification code</label>
		<input id="Auth-Enroll-Code" class="cst-auth-otp" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" autofocus />
	</div>
	<button type="submit" class="cst-auth-button" id="Auth-Enroll-Confirm">Confirm and continue</button>
</form>
<div class="cst-auth-actions">
	<a onclick="_Pict.views['Plansheet-Auth'].enrollResend()">Resend code</a>
	<a onclick="_Pict.views['Plansheet-Auth'].enrollSignOut()">Sign out</a>
</div>`
		},
		{
			Hash: 'Auth-Providers-Template',
			Template: /*html*/`
<div class="cst-auth-divider">or continue with</div>
<div class="cst-auth-providers">
	{~TS:Auth-Provider-Row-Template:AppData.Auth.Providers~}
</div>`
		},
		{
			Hash: 'Auth-Provider-Row-Template',
			Template: /*html*/`<a class="cst-auth-provider" href="{~D:Record.BeginURL~}">{~D:Record.Label~}</a>`
		},
		{
			Hash: 'Auth-Error-Template',
			Template: /*html*/`<div class="cst-auth-error">{~D:Record.Message~}</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Auth-Display',
			TemplateHash:   'Auth-Display',
			ContentDestinationAddress: '#Plansheet-Workspace'
		}
	]
};

function _maskEmail(pEmail)
{
	let tmpStr = String(pEmail || '');
	let tmpAt = tmpStr.indexOf('@');
	if (tmpAt < 1) { return 'your email'; }
	return tmpStr.charAt(0) + '***' + tmpStr.slice(tmpAt);
}

class PictViewAuth extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.pict.AppData.Auth = this.pict.AppData.Auth || { LoggedIn: false, User: null, Providers: [], LastError: null };
		this.pict.AppData.Auth.Brand = this.pict.AppData.Auth.Brand ||
			{ Name: libBrand.Name || 'Plansheet', Tagline: libBrand.Tagline || '', Mark: libBrand.Icon || '' };
		this.pict.AppData.Auth.UISlot = this.pict.AppData.Auth.UISlot || { Mode: 'login', Login: [{}], Signup: [], Verify: [], Recovery: [], EnrollSend: [], EnrollCode: [], HasProviders: [], Error: [] };
		this.pict.AppData.Auth.UISlot.Mode = this.pict.AppData.Auth.UISlot.Mode || 'login';
		this._refreshSlots();
	}

	switchMode(pMode)
	{
		this.pict.AppData.Auth.UISlot.Mode = (pMode === 'signup' || pMode === 'verify' || pMode === 'enroll') ? pMode : 'login';
		this.pict.AppData.Auth.LastError = null;
		this.pict.AppData.Auth.ResendNote = null;
		this.pict.AppData.Auth.EnrollFlow = null;
		this.pict.AppData.Auth.RecoveryMode = false;
		this._refreshSlots();
		this.render();
	}

	_refreshSlots()
	{
		let tmpAuth = this.pict.AppData.Auth;
		let tmpMode = tmpAuth.UISlot.Mode;
		let tmpProviders = (tmpAuth.Providers || []).map((pProvider) =>
			Object.assign({}, pProvider,
				{
					Label: 'Continue with ' + libProviderLabels.labelForProvider(pProvider.Name)
				}));
		tmpAuth.Providers = tmpProviders;
		tmpAuth.UISlot.Login = (tmpMode === 'login') ? [{}] : [];
		tmpAuth.UISlot.Signup = (tmpMode === 'signup') ? [{}] : [];
		let tmpChallenge = tmpAuth.PendingChallenge || null;
		let tmpRecoveryMode = !!tmpAuth.RecoveryMode;
		tmpAuth.UISlot.Verify = (tmpMode === 'verify' && tmpChallenge && !tmpRecoveryMode)
			? [{ MaskedDestination: tmpChallenge.MaskedDestination || 'your account', Channel: tmpChallenge.Channel || 'email', ResendNote: tmpAuth.ResendNote || '' }]
			: [];
		tmpAuth.UISlot.Recovery = (tmpMode === 'verify' && tmpChallenge && tmpRecoveryMode) ? [{}] : [];
		let tmpEnrollUser = tmpAuth.User || {};
		let tmpEnrollFlow = tmpAuth.EnrollFlow || null;
		let tmpOrgLine = tmpEnrollUser.CustomerName
			? (tmpEnrollUser.CustomerName + ' requires two-step verification for password sign-in.')
			: 'Your organization requires two-step verification for password sign-in.';
		tmpAuth.UISlot.EnrollSend = (tmpMode === 'enroll' && !(tmpEnrollFlow && tmpEnrollFlow.Token))
			? [{ OrgLine: tmpOrgLine, EmailMasked: _maskEmail(tmpEnrollUser.Email) }]
			: [];
		tmpAuth.UISlot.EnrollCode = (tmpMode === 'enroll' && tmpEnrollFlow && tmpEnrollFlow.Token)
			? [{ Masked: tmpEnrollFlow.Masked || _maskEmail(tmpEnrollUser.Email) }]
			: [];
		tmpAuth.UISlot.HasProviders = (tmpProviders.length > 0) ? [{}] : [];
		tmpAuth.UISlot.Error = tmpAuth.LastError ? [{ Message: tmpAuth.LastError }] : [];
	}

	submitLogin()
	{
		let tmpUser = (document.getElementById('Auth-Login-Username') || {}).value || '';
		let tmpPass = (document.getElementById('Auth-Login-Password') || {}).value || '';
		if (!tmpUser || !tmpPass)
		{
			this.pict.AppData.Auth.LastError = 'Username and password are required.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Login-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.AuthClient.login(tmpUser, tmpPass).then((pResult) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pResult === 'challenge')
			{
				// Two-step verification: swap to the code-entry card.
				this.switchMode('verify');
				return;
			}
			if (pResult)
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	// Passwordless: email the user a one-time sign-in link. Uses the reusable magic-link engine
	// (Plansheet-MagicLogin). The request is anti-enumeration, so the note is the same whether or not an
	// account matches -- we only ask for an email in the sign-in field first.
	sendMagicLink()
	{
		let tmpEmail = String((document.getElementById('Auth-Login-Username') || {}).value || '').trim();
		if (!tmpEmail || tmpEmail.indexOf('@') < 1)
		{
			this._setMagicNote('Enter your email in the field above, then click here.');
			return;
		}
		let tmpMagic = this.pict.views['Plansheet-MagicLogin'];
		if (!tmpMagic || typeof tmpMagic.requestMagicLink !== 'function')
		{
			this._setMagicNote('Sign-in links are not available right now.');
			return;
		}
		this._setMagicNote('Sending...');
		tmpMagic.requestMagicLink(tmpEmail, () =>
		{
			this._setMagicNote('Check your email for a one-time sign-in link.');
		});
	}

	_setMagicNote(pText)
	{
		if (typeof document === 'undefined') { return; }
		let tmpNote = document.getElementById('Auth-Magic-Note');
		if (tmpNote) { tmpNote.textContent = pText || ''; }
	}

	submitSignup()
	{
		let tmpEmail = (document.getElementById('Auth-Signup-Email') || {}).value || '';
		let tmpLogin = (document.getElementById('Auth-Signup-Login') || {}).value || '';
		let tmpDisplay = (document.getElementById('Auth-Signup-Display') || {}).value || '';
		let tmpPass = (document.getElementById('Auth-Signup-Password') || {}).value || '';
		if (!tmpEmail || !tmpLogin || !tmpPass)
		{
			this.pict.AppData.Auth.LastError = 'Email, username, and password are required.';
			this._refreshSlots();
			this.render();
			return;
		}
		if (tmpPass.length < 8)
		{
			this.pict.AppData.Auth.LastError = 'Password must be at least 8 characters.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Signup-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.AuthClient.signup(
			{
				Email: tmpEmail,
				LocalLogin: tmpLogin,
				DisplayName: tmpDisplay,
				Password: tmpPass
			}).then((pOk) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pOk)
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	submitVerify()
	{
		let tmpCode = ((document.getElementById('Auth-Verify-Code') || {}).value || '').trim();
		if (!tmpCode)
		{
			this.pict.AppData.Auth.LastError = 'Enter the code we sent you.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Verify-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.AppData.Auth.ResendNote = null;
		this.pict.providers.AuthClient.verifyLoginCode(tmpCode).then((pOk) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pOk)
			{
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	toggleRecovery(pOn)
	{
		this.pict.AppData.Auth.RecoveryMode = !!pOn;
		this.pict.AppData.Auth.LastError = null;
		this.pict.AppData.Auth.ResendNote = null;
		this._refreshSlots();
		this.render();
	}

	submitRecovery()
	{
		let tmpCode = ((document.getElementById('Auth-Recovery-Code') || {}).value || '').trim();
		if (!tmpCode)
		{
			this.pict.AppData.Auth.LastError = 'Enter one of your recovery codes.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Recovery-Submit');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.AuthClient.useRecoveryCode(tmpCode).then((pOk) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			if (pOk)
			{
				this.pict.AppData.Auth.RecoveryMode = false;
				let tmpApp = this.pict.PictApplication;
				if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
			}
			else
			{
				this._refreshSlots();
				this.render();
			}
		});
	}

	resendCode()
	{
		this.pict.providers.AuthClient.resendLoginCode().then((pMasked) =>
		{
			this.pict.AppData.Auth.LastError = pMasked ? null : 'Could not resend a code. Please sign in again.';
			this.pict.AppData.Auth.ResendNote = pMasked ? ('A new code is on the way to ' + pMasked + '.') : null;
			this._refreshSlots();
			this.render();
		});
	}

	cancelVerify()
	{
		this.pict.providers.AuthClient.cancelChallenge();
		this.pict.AppData.Auth.ResendNote = null;
		this.switchMode('login');
	}

	// Forced enrollment (org requires 2FA, this account is not enrolled). The
	// session is signed in but restricted; these calls reach the allowed
	// /1.0/Account/TwoFactor endpoints. Email channel keeps it recoverable.
	enrollSendCode()
	{
		let tmpButton = document.getElementById('Auth-Enroll-Send');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.AppData.Auth.LastError = null;
		this.pict.providers.UserAPI.enableTwoFactor('email').then((pBody) =>
		{
			this.pict.AppData.Auth.EnrollFlow = { Token: pBody.ChallengeToken, Masked: pBody.MaskedDestination };
			this._refreshSlots();
			this.render();
		}).catch((pErr) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			this.pict.AppData.Auth.LastError = pErr.message || 'Could not send a code.';
			this._refreshSlots();
			this.render();
		});
	}

	enrollResend()
	{
		this.pict.providers.UserAPI.enableTwoFactor('email').then((pBody) =>
		{
			this.pict.AppData.Auth.EnrollFlow = { Token: pBody.ChallengeToken, Masked: pBody.MaskedDestination };
			this.pict.AppData.Auth.LastError = null;
			this._refreshSlots();
			this.render();
		}).catch(() => {});
	}

	enrollConfirm()
	{
		let tmpCode = ((document.getElementById('Auth-Enroll-Code') || {}).value || '').trim();
		let tmpFlow = this.pict.AppData.Auth.EnrollFlow || {};
		if (!tmpCode)
		{
			this.pict.AppData.Auth.LastError = 'Enter the code we emailed you.';
			this._refreshSlots();
			this.render();
			return;
		}
		let tmpButton = document.getElementById('Auth-Enroll-Confirm');
		if (tmpButton) tmpButton.disabled = true;
		this.pict.providers.UserAPI.confirmTwoFactor(tmpFlow.Token, tmpCode).then(() =>
		{
			this.pict.AppData.Auth.EnrollFlow = null;
			if (this.pict.AppData.Auth.User) { this.pict.AppData.Auth.User.MustEnroll2FA = false; }
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.onAuthChanged === 'function') tmpApp.onAuthChanged();
		}).catch((pErr) =>
		{
			if (tmpButton) tmpButton.disabled = false;
			this.pict.AppData.Auth.LastError = pErr.message || 'Incorrect code.';
			this._refreshSlots();
			this.render();
		});
	}

	enrollSignOut()
	{
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.signOut === 'function') { tmpApp.signOut(); return; }
		this.pict.providers.AuthClient.logout().then(() => this.switchMode('login'));
	}

	onBeforeRender(pRenderable)
	{
		this._refreshSlots();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		// TEMP DIAGNOSTIC ([auth-boot]) for the OAuth-button cold-load issue: log what actually painted --
		// the HasProviders slot the template read and the OAuth buttons that ended up in the DOM. Remove
		// once confirmed (grep "auth-boot").
		try
		{
			let tmpHas = (this.pict.AppData.Auth && this.pict.AppData.Auth.UISlot && this.pict.AppData.Auth.UISlot.HasProviders) ? this.pict.AppData.Auth.UISlot.HasProviders.length : 0;
			let tmpBtns = (typeof document !== 'undefined') ? document.querySelectorAll('.cst-auth-provider').length : 0;
			console.log('[auth-boot] +' + Math.round((typeof performance !== 'undefined' ? performance.now() : 0)) + 'ms auth render -- HasProviders=' + tmpHas + ', buttons in DOM=' + tmpBtns);
		}
		catch (pErr) { /* no-op */ }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewAuth;
module.exports.default_configuration = _ViewConfiguration;
